(function() {
    'use strict';

    angular
        .module('formonlineApp', [
            'ngStorage',
            'tmh.dynamicLocale',
            'pascalprecht.translate',
            'ngResource',
            'ngCookies',
            'ngAria',
            'ngCacheBuster',
            'ngFileUpload',
            'ngMessages',
            'ngSanitize',
            'ui.bootstrap',
            'ui.bootstrap.datetimepicker',
            'ui.router',
            'ui.select',
            'toaster',
            'infinite-scroll',
            // jhipster-needle-angularjs-add-module JHipster will add new module here
            'angular-loading-bar',
            'ui.bootstrap.showErrors',
			// app modules (core and co)
			'Core',
			'CoreUtils',
            'vcRecaptcha',
            'ngMask'
        ])
        .run(run);

    run.$inject = ['stateHandler', 'translationHandler', '$http'];

    function run(stateHandler, translationHandler, $http) {
        stateHandler.initialize();
        translationHandler.initialize();
    }
})();
